import { styled, Switch } from '@mui/material';
import * as React from 'react';
import { variantMapping } from './variants';

const CustomizedSwitch = styled(Switch)(({ variant }) => ({
  width: variantMapping[variant].width,
  height: variantMapping[variant].height,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: `translateX(${variantMapping[variant].translateX}px)`,
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: variantMapping[variant].backgroundColor,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: variantMapping[variant].thumbColor,
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: 'red',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: variantMapping[variant].thumbWidth,
    height: variantMapping[variant].thumbHeight,
  },
  '& .MuiSwitch-track': {
    borderRadius: variantMapping[variant].borderRadius,
    backgroundColor: variantMapping[variant].trackBackground,
    opacity: 1,
  },
}));

const CommonSwitch = ({ variant, ...props }) => (
  <CustomizedSwitch variant={variant} defaultChecked {...props} />
);

export default CommonSwitch;
